const formatCurrency = (val) => {
  let showFraction = 0
  if (val % 1 > 0) {
    showFraction = 2
  }

  return new Intl.NumberFormat("da-DK", {
    minimumFractionDigits: showFraction,
    maximumFractionDigits: showFraction,
  }).format(val)
}

export default formatCurrency
